<template>
  <div class="addedit-lead center">
    <div class="header mb-6">
      <vs-button
        color="dark"
        type="flat"
        icon-pack="feather"
        icon="icon-arrow-left"
        class="p-0"
        @click="goBack()"
      ></vs-button>
      <div class="w-1/2 justify-right">
        <h2 class="pl-2">{{ editRoute ? $t('labels.edit_country') : $t('labels.add_country') }}</h2>
      </div>
    </div>
    <form @submit.prevent="checkValidation()" autocomplete="off">
      <vx-card class="addedit-lead-card">
        <div class="vx-row w-full m-0">
          <div class="vx-col sm: w-full md:w-1/3 mb-4 pl-0">
            <label>{{$t('labels.name')}}</label>
            <vs-input
              type="text"
              class="w-full mt-1"
              name="country_name"
              maxlength="50"
              v-model="name"
              icon-no-border
              :placeholder="$t('labels.country_name')"
              v-validate="'required|max:50|alpha_spaces'"
            />
            <span class="text-danger text-sm">{{ errors.first('country_name') }}</span>
          </div>
          <div class="vx-col sm: w-full md:w-1/3 mb-4">
            <label>{{$t('labels.iso_code')}}</label>
            <vs-input
              type="text"
              class="w-full mt-1"
              name="iso_code"
              maxlength="255"
              v-model="code"
              icon-no-border
              :placeholder="$t('labels.iso_code')"
              v-validate="'required|length:2'"
            />
            <span class="text-danger text-sm">{{ errors.first('iso_code') }}</span>
          </div>
          <div class="vx-col sm: w-full md:w-1/3 mb-4 pr-0">
            <label>{{$t('labels.nationality')}}</label>
            <vs-input
              type="text"
              class="w-full mt-1"
              name="nationality"
              maxlength="255"
              v-model="nationality"
              icon-no-border
              :placeholder="$t('labels.nationality')"
            />
            <span class="text-danger text-sm">{{ errors.first('nationality') }}</span>
          </div>
        </div>
        <div class="mt-2 btn-lead flex justify-center">
          <vs-button
            class="vs-component vs-button md:w-auto md:mr-3 md:mt-0 md:mb-0 vs-button-primary vs-button-filled login-btn"
            :disabled="button_loading"
            id="create-country"
            button="submit"
          >{{ editRoute ? $t('labels.update_country') : $t('labels.add_country') }}</vs-button>
        </div>
      </vx-card>
    </form>
  </div>
</template>
<script>
export default {
  data() {
    return {
      name: "",
      code: "",
      nationality: ""
    };
  },
  computed: {
    editRoute() {
      if (this.$route.params.id) {
        return this.$route.params.id;
      } else {
        return false;
      }
    }
  },
  mounted() {
    this.setValidationMessage();
    if (this.editRoute) {
      this.getCountry();
    }
  },
  methods: {
    checkValidation() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.createUpdateCountry();
        }
      });
    },
    async createUpdateCountry() {
      let input = {
        name: this.name,
        code: this.code,
        nationality: this.nationality
      };
      let url = this.editRoute
        ? "/country/update/" + this.editRoute
        : "/country/create";
      let response = await this.getHTTPPostResponse(
        url,
        input,
        "#create-country",
        true
      );
      if (response) {
        this.$router.push({ name: "Countries" });
      }
    },
    async getCountry() {
      let response = await this.getHTTPGetResponse(
        "/country/get/" + this.editRoute
      );
      if (response) {
        let data = response.data;
        let country = data.country;
        this.name = country.name;
        this.code = country.code;
        this.nationality = country.nationality;
      }
    },
    goBack() {
      history.back();
    }
  }
};
</script>
